import React from 'react';
import { useCurrentStateAndParams, useRouter } from '@uirouter/react';
import { UserPermissionsSidebarInternal } from '@react/Pages/UsersPage/UserPermissionSidebar/UserPermissionsSidebar';

interface UserPermissionsSidebarOwnProps {
  routerProps: {
    backPath: string;
  };
}

export const UserPermissionsSidebar: React.FC<UserPermissionsSidebarOwnProps> = ({ routerProps }) => {
  const router = useRouter();
  const { params } = useCurrentStateAndParams();

  const closeHandler = () => {
    router.stateService.go(routerProps.backPath);
  };

  return <UserPermissionsSidebarInternal onClose={closeHandler} userId={params.id} />;
};
